// Textos del módulo Calificaciones (estadísticas del QR post-pago). Ver src/i18n/textos.ts.
// El formulario público del comensal (public-calificacion-form.tsx) NO usa este archivo.
import { defineTextos } from '../textos.ts';

export const textosCalificaciones = defineTextos({
  nDe5: '{n} de 5',
  errorCargando: 'Error cargando calificaciones',
  reiniciasteApi: ' ¿Reiniciaste la API? Las rutas /api/calificaciones se cargan al arrancar.',
  titulo: 'Calificaciones',
  respondidas: 'Respondidas',
  tasaRespuesta: 'Tasa de respuesta',
  atencion: 'Atención',
  comida: 'Comida',
  recomendacion: 'Recomendación',
  mesEnCurso: 'Mes en curso',
  todoHistorico: 'Todo el histórico',
  periodoAria: 'Período',
  experienciaComensales: 'Experiencia de los comensales (QR post-pago) — sede',
  cargando: 'Cargando calificaciones…',
  sinCalificaciones: 'Aún no hay calificaciones. El QR aparece en la pantalla de "Orden completamente pagada" al cobrar un pedido — el comensal lo escanea y responde desde su celular.',
  colMesero: 'Mesero',
  colQrsEmitidos: 'QRs emitidos',
  respuestasRecientes: 'Respuestas recientes ({n})',
  sinMesero: 'Sin mesero',
  ventaN: ' · venta #{id}',
  abiertoCerrado: 'Abierto {abierto} → cerrado {cerrado}',
  respondidaEl: ' · respondida {fecha}',
  recomCorto: 'Recom.',
  velocidadN: 'Velocidad {n} · ',
  limpiezaN: 'Limpieza {n} · ',
  ambienteN: 'Ambiente {n}',
}, {
  nDe5: '{n} of 5',
  errorCargando: 'Error loading ratings',
  reiniciasteApi: ' Did you restart the API? The /api/calificaciones routes load at startup.',
  titulo: 'Ratings',
  respondidas: 'Answered',
  tasaRespuesta: 'Response rate',
  atencion: 'Service',
  comida: 'Food',
  recomendacion: 'Recommendation',
  mesEnCurso: 'Current month',
  todoHistorico: 'All history',
  periodoAria: 'Period',
  experienciaComensales: 'Guest experience (post-payment QR), branch',
  cargando: 'Loading ratings…',
  sinCalificaciones: 'No ratings yet. The QR shows up on the "Order fully paid" screen when you charge an order; the guest scans it and answers from their phone.',
  colMesero: 'Waiter',
  colQrsEmitidos: 'QRs issued',
  respuestasRecientes: 'Recent responses ({n})',
  sinMesero: 'No waiter',
  ventaN: ' · sale #{id}',
  abiertoCerrado: 'Opened {abierto} → closed {cerrado}',
  respondidaEl: ' · answered {fecha}',
  recomCorto: 'Recom.',
  velocidadN: 'Speed {n} · ',
  limpiezaN: 'Cleanliness {n} · ',
  ambienteN: 'Atmosphere {n}',
});
